import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-promo-code-popup',
  templateUrl: './promo-code-popup.component.html',
  styleUrls: ['./promo-code-popup.component.css'],
})
export class PromoCodePopupComponent implements OnInit {
  @Output() enableBuyTksNew = new EventEmitter();
  @Input() promoCode: string;

  constructor(public activeModal: NgbActiveModal) {}

  ngOnInit(): void {
  }

  enableBuyTksChild(): void {
    const promoCode = {isFromPromoCodePopup: true, promoCode: this.promoCode};
    this.enableBuyTksNew.emit(promoCode);
    this.closeModal();
  }

  closeModal(): void {
    this.activeModal.close();
  }
}
